<template>
  <div class="switch-checkbox">
    <div class="switch--switch">

      <label v-bind:for="id">
        <input type="checkbox"
               v-bind:name="name"
               v-bind:class="className"
               v-bind:id="id"
               v-bind:value="value"
               v-bind:checked="value"
               v-bind:disabled="disabled"
               v-bind:required="required"
               v-on:change="updateInput">
        <div class="slider round"></div>
      </label>
    </div>

    <div class="switch--label" @click="toggleChecked" v-html="label"></div>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: false
      },
      className: {
        type: String,
        required: false
      },
      id: {
        type: String,
        required: false
      },
      value: {
        type: Boolean,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false
      },
      required: {
        type: Boolean,
        required: false,
        default: false
      },
      label: {
        type: String,
        required: false,
        default: ''
      }
    },
    methods: {
      toggleChecked () {
        if (this.disabled) return

        this.$emit('input', !this.value)
      },
      updateInput: function (event) {
        this.$emit('input', event.target.checked)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// client/components/ui/slider.vue